export const CSS_LOOP = 8;
